import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { SITE_URL, WWW_SITE_URL } from "@/content/siteContent";
import LandingPage from "@/pages/LandingPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import RegulationPage from "@/pages/RegulationPage";

function RouterObservers() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  useEffect(() => {
    const configuredWwwHost = WWW_SITE_URL ? new URL(WWW_SITE_URL).hostname : "";
    const shouldRedirectFromWww =
      window.location.hostname.startsWith("www.") &&
      (!configuredWwwHost || window.location.hostname === configuredWwwHost);

    if (shouldRedirectFromWww && SITE_URL) {
      window.location.replace(`${SITE_URL}${location.pathname}${location.search}${location.hash}`);
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <>
      <Toaster />
      <BrowserRouter>
        <RouterObservers />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/regolamento" element={<RegulationPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/success" element={<PaymentSuccessPage />} />
          <Route path="/cancel" element={<PaymentCancelPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
